import * as React from "react";
import {useEffect, useContext} from "react";
import {Event} from "../queries/event";
import {JoinContext} from "../joinContext";

export const useJoin = (payload) => {
    const {state, dispatch} = useContext(JoinContext);
    useEffect(()=> {
        dispatch({type: "initJoin",payload:payload});
    },[])

    const join = async (eventId) => {
        dispatch({type: "join"});
        const res = await Event.joinEvent(eventId)
        return res.status
    }

    const leave = async (eventId) => {
        dispatch({type: "leave"});
        const res = await Event.leaveEvent(eventId)
        return res.status
    }
    return {join,joinStatus:state,leave}
}